export interface LabelValue {
  label:string, value:string,
}

export interface ActiveLabelValue extends LabelValue {
  checked: boolean
}

export interface LabelValueOptions {
  valueAutoFill?: boolean;
  valueAutoFillTransform?: string;
  inputType: string;
}

export enum ValueAutoFillTransformTypes {
  CamelCase = 'camelCase',
}
